<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Processamento</h2>
    </div>

    <div class="tds-row">
       <a>Receber somente tipo de financiamento que depende de crédito?</a>
    </div>
    <div class="tds-row">
        <tds-radio-button name=”my-radio-button” value=”radio-value”> 
        </tds-radio-button> Sim
        <tds-radio-button name=”my-radio-button” value=”radio-value”> 
        </tds-radio-button> Não
        <tds-radio-button name=”my-radio-button” value=”radio-value”> 
        </tds-radio-button> Tudo
    </div>
    <div class="tds-row">
        <tds-button
            type="button"
            variant="primary"
            size="lg"
            text="Iniciar Processamento"
            animation="none"
            tds-aria-label="undefined"
            name=""
            value=""
        ></tds-button>
    </div>
</div>